import requests from "./httpService";

const MembershipServiceListServices = {

    getServiceMembership: async () => {
        return requests.get(`/service-membership`);
    },
    statusUpdateMembershipService: async (id, body) => {
        return requests.patch(`/service-membership/${id}`, body);
    },
    updateMembershipsService: async (id, body) => {
        return requests.put(`/service-membership/${id}`, body);
    },
    createMembershipService: async (body) => {
        return requests.post(`/service-membership`, body);
    },
    deleteMembershipService: async (id) => {
        return requests.delete(`/service-membership/${id}`);
    },

    getServiceGuest: async () => {
        return requests.get(`/service/guest`);
    },
    getMembershipGuest: async () => {
        return requests.get(`/membership/guest/membership`);
    },

}
export default MembershipServiceListServices;